<template>
  <div>
      <div class="kit__utils__heading">
          <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
      </div>
       <div class="card">
         <div class="card-header">
          <b-row>
          <b-col cols="12" lg="6" md="12">
            <b-col>
              <b-col>
                <b-form-group label-cols-sm="3" label="ค้นหาแบบพิเศษ" class="mb-0">
                  <a-input-search v-model="formkey.keyWord" placeholder="" enter-button="Search" @search="setKeyword"
                    allow-clear />
                  <span class="form-text"><span class="text-danger">*</span>ค้นหาด้วย <span
                      class="text-danger">ยูสเซอร์เนม</span>หรือ<span class="text-danger">ชื่อบัญชี</span>หรือ<span class="text-danger">เลขบัญชี</span></span>
                </b-form-group>
              </b-col>
            </b-col>
          </b-col>
          <b-col cols="6" lg="6" md="6">
            <b-col>
              <b-col>
                <div class="d-flex justify-content-end" style="margin: 3px;">
              <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert',null)">เพิ่มลูกค้า SBO</a>
                </div>
              </b-col>
            </b-col>
          </b-col>
        </b-row>
           <!-- <div class="d-flex flex-column justify-content-center mr-auto">
             <h5 class="mb-0"></h5>
           </div>
           <div class="d-flex flex-column justify-content-center">
             <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มบัญชีดำ</a>
           </div> -->
         </div>
         <div class="card-body">
           <a-table :columns="columns" :dataSource="data" rowKey='id' :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }" :scroll="{ x: 1500 }" :loading="loadingTable">
             <!-- <span slot="status" slot-scope="text">
               <a-tag :color="(text)?'green':'red'">
                 {{(text)?'บล็อคการใช้งาน':(!text)?'ปิดการบล็อค':"ไม่พบข้อมํูล"}}
               </a-tag>
             </span> -->
             <span slot="status" slot-scope="text,record">
               <a-switch :checked="!!parseInt(record.status)" @change="updateStatus(record.id,!record.status)" />
             </span>
             <span slot="Action" slot-scope="text,record">
               <a-dropdown>
                 <a-menu slot="overlay">
                   <a-menu-item @click="showModal('update',record.id,record.bankAcountCode)">แก้ไขลูกค้า SBO </a-menu-item>
                   <a-menu-item :disabled="record.bankAcountCode !== null " @click="checkBankAccount(record)">ตรวจสอบบัญชีธนาคาร </a-menu-item>
                 </a-menu>
                 <a-button style="margin-left: 8px"> จัดการ
                   <a-icon type="down" />
                 </a-button>
               </a-dropdown>
             </span>
           </a-table>
         </div>
       </div>
       <a-modal
         title="ตรวจสอบบัญชีธนาคาร"
         width="1000px"
         v-model="visibleCheckBankAccount"
         :ok-button-props="{ props: { disabled: disabledCheck } }"
         :confirm-loading="confirmLoadingCheck"
         ok-text="ยืนยัน"
         cancel-text="ยกเลิก"
         @ok="handleOkCheck"
         @cancel="handleCancelCheck">
            <a-form-model :model="formcheck" layout="horizontal" >
              <a-row>
                <a-col :span="12" style="border-style: none inset none none; padding: 0 18px 0 0">
                  <h5 class="mb-0">ตรวจสอบบัญชีธนาคาร</h5>
                <a-form-model-item label="ธนาคาร">
                    <a-select v-model="formcheck.bankId" placeholder="กรุณาเลือกข้อมูล">
                    <a-select-option v-for="(item , index) in bank" :key="index" :value="item.id">
                        {{ item.bankName }}
                    </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="เลขบัญชีธนาคาร">
                    <a-input v-model="formcheck.accountNumber" />
                </a-form-model-item>
                <a-form-model-item label="ชื่อบัญชีธนาคาร">
                    <a-input v-model="formcheck.bankAccountName" />
                </a-form-model-item>
                <a-form-model-item>
                  <a-button type="primary" @click="sendCheckBankAccountUpdate()">
                    ตรวจสอบ
                  </a-button>
                </a-form-model-item>
                </a-col>
                <a-col :span="12" style="padding: 0  0 0 18px">
                  <h5 class="mb-0">บัญชีธนาคาร</h5>
                  <a-spin tip="Loading..." :spinning="spinning">
                    <div class="spin-content">
                      <a-form-model-item label="ธนาคาร">
                        <a-input v-model="userBank.bank" />
                      </a-form-model-item>
                      <a-form-model-item label="เลขบัญชีธนาคาร">
                          <a-input v-model="userBank.accountNumber" />
                      </a-form-model-item>
                      <a-form-model-item label="ชื่อบัญชีธนาคาร">
                        <a-input v-model="userBank.accountToDisplayName" />
                      </a-form-model-item>
                      <a-form-model-item label="ชื่อบัญชีธนาคารอังกฤษ">
                          <a-input v-model="userBank.accountName" />
                      </a-form-model-item>
                    </div>
                  </a-spin>
                </a-col>
               </a-row>
            </a-form-model>
        </a-modal>
      <a-modal :title="this.form.title" :width="widthModal" v-model="visible" :ok-button-props="{ props: { disabled: disabledCheck } }"
       :confirm-loading="confirmLoadingCheck"  ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk" @cancel="handleCancel">
          <a-form-model ref="ruleForm" :model="form" :layout="layout" :rules="rules">
              <a-form-model-item label="พาร์ทเนอร์" prop="partnerSboId">
              <a-select
                  v-model="form.partnerSboId" placeholder="กรุณาเลือกข้อมูล">
                  <a-select-option value="">
                  กรุณาเลือกข้อมูล
                  </a-select-option>
                  <a-select-option v-for="(item , index) in Partner" :key="index" :value="item.id">
                  {{ item.name }}
                  </a-select-option>
              </a-select>
              </a-form-model-item>
              <a-row>
              <a-col :span="spanForm" :style="styleForm">
              <a-form-model-item label="ยูสเซอเนม" prop="username">
                  <a-input v-model="form.username" :disabled="disabledBank"/>
              </a-form-model-item>
              <a-form-model-item label="ธนาคาร" prop="bankId">
                  <a-select v-model="form.bankId" placeholder="กรุณาเลือกข้อมูล" :disabled="disabledBank">
                  <a-select-option v-for="(item , index) in bank" :key="index" :value="item.id">
                      {{ item.bankName }}
                  </a-select-option>
                  </a-select>
              </a-form-model-item>
              <a-form-model-item label="เลขบัญชีธนาคาร" prop="bankAccountNumber">
                  <a-input v-model="form.bankAccountNumber" :disabled="disabledBank"/>
              </a-form-model-item>
              <a-form-model-item label="ชื่อบัญชีธนาคาร" prop="bankAccountName" >
                  <a-input v-model="form.bankAccountName" :disabled="disabledBank"/>
              </a-form-model-item>
              <a-form-model-item label="เบอร์โทร">
                  <a-input v-model="form.phoneNumber" />
              </a-form-model-item>
              <a-form-model-item label="ไลน์ไอดี">
                  <a-input v-model="form.lineId" />
              </a-form-model-item>
              <a-form-model-item :style="styleButton">
                <a-button type="primary" @click="sendCheckBankAccount()">
                  ตรวจสอบบัญชีธนาคาร
                </a-button>
              </a-form-model-item>
              </a-col>
              <a-col :span="spanCheck" :style="styleCheck">
                <a-spin tip="Loading..." :spinning="spinning">
                  <div class="spin-content">
                    <a-form-model-item label="ธนาคาร">
                      <a-input v-model="userBank.bank" />
                    </a-form-model-item>
                    <a-form-model-item label="เลขบัญชีธนาคาร">
                        <a-input v-model="userBank.accountNumber" />
                    </a-form-model-item>
                    <a-form-model-item label="ชื่อบัญชีธนาคาร">
                      <a-input v-model="userBank.accountToDisplayName" />
                    </a-form-model-item>
                    <a-form-model-item label="ชื่อบัญชีธนาคารอังกฤษ">
                        <a-input v-model="userBank.accountName" />
                    </a-form-model-item>
                  </div>
                </a-spin>
              </a-col>
        </a-row>
          </a-form-model>

      </a-modal>
  </div>
</template>

<script>
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
// import moment from 'moment'
// import axios from 'axios'
import momentTz from 'moment-timezone'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  data() {
    return {
      visible: false,
      visibleCheckBankAccount: false,
      disabledBank: false,
      loadingTable: false,
      spinning: false,
      layout: 'vertical',
      widthModal: '560px',
      styleForm: 'padding: 0; border-style: none;',
      styleCheck: 'padding: 0  0 0 18px; display: none;',
      spanForm: 24,
      spanCheck: 0,
      styleButton: 'display: block;',
      disabledCheck: true,
      confirmLoadingCheck: false,
      data: [],
      bank: [],
      Partner: [],
      formkey: {
        keyWord: '',
      },
      columns: [
        {
          title: 'ลำดับ',
          key: 'id',
          dataIndex: 'id',
        },
        {
          title: 'BankAcountCode',
          key: 'bankAcountCode',
          dataIndex: 'bankAcountCode',
          width: 170,
        },
        {
          title: 'พาร์ทเนอร์',
          key: 'partnerSBOName',
          dataIndex: 'partnerSBOName',
          filters: [
          // { text: 'MUGHUAY', value: 'MUGHUAY' },
          // { text: 'DUCKBET', value: 'DUCKBET' },
          ],
          onFilter: (value, record) => record.partnerSBOName.toLowerCase().includes(value.toLowerCase()),
          width: 150,
        },
        {
          title: 'ยูสเซอร์เนม',
          key: 'username',
          dataIndex: 'username',
          width: 105,
        },
        {
          title: 'บัญชีธนาคาร',
          key: 'bankServiceAccount',
          dataIndex: 'bankServiceAccount',
          width: 300,
        },
        {
          title: 'เบอร์โทร',
          key: 'phoneNumber',
          dataIndex: 'phoneNumber',
        },
        {
          title: 'ไลน์ไอดี',
          key: 'lineId',
          dataIndex: 'lineId',
        },
        {
          title: 'สถานะ',
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
          },
          //   fixed: 'right',
        },
        {
          title: 'วันที่อัปเดท',
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
          },
          //   fixed: 'right',

        },
        {
          title: 'ตัวเลือก',
          key: 'Action',
          dataIndex: 'bankServiceId',
          scopedSlots: { customRender: 'Action' },
        },
      ],
      form: {
        partnerSboId: null,
        username: null,
        phoneNumber: null,
        bankId: null,
        bankAccountName: null,
        bankAccountNumber: null,
        lineId: null,
      },
      formcheck: {
        bankId: null,
        bankAccountName: null,
        accountNumber: null,
        username: null,
      },
      userBank: {
        icon: 'https://cdn.duckbet.com/wl/?id=iGPZ8yN6Vum7J2sYtrFYzJesTo6UZ7yt',
        bank: null,
        accountNumber: null,
        accountName: null,
        accountToDisplayName: null,
      },
      rules: {
        partnerSboId: [
          { required: true, message: 'กรุณาเลือกพาร์ทเนอร์', trigger: 'change' },
        ],
        username: [
          { required: true, message: 'กรุณากรอก ยูสเซอเนม', trigger: 'blur' },
          { min: 2, max: 50, message: 'ความยาวตัวอักษรควรเป็น 2 ถึง 50', trigger: 'blur' },
        ],
        bankId: [
          { required: true, message: 'กรุณาเลือกธนาคาร', trigger: 'change' },
        ],
        bankAccountName: [
          { required: true, message: 'กรุณากรอก ชื่อบัญชีธนาคาร', trigger: 'blur' },
        ],
        bankAccountNumber: [
          { required: true, message: 'กรุณากรอก บัญชีธนาคาร', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    setKeyword(value, event) {
      this.getBlackList()
    },
    async getBlackList() {
      this.loadingTable = !this.loadingTable
      await apiClient.post('/memberSBO/getData', this.formkey).then(response => {
        const res = response.data
        this.loadingTable = !this.loadingTable
        if (res.code === '000') {
          this.data = res.responseData.data
          if (this.data.length > 0) {
            const listPartner = this.data.map(function(item, pos) {
              return { text: item.partnerSBOName, value: item.partnerSBOName }
            })
            this.columns[2].filters = [
              ...new Map(listPartner.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    showModal(type, id = null, bankAcountCode = null) {
      this.disabledBank = false
      this.clearForm()
      this.form.type = type
      this.form.title = (type === 'insert') ? 'เพิ่มลูกค้า SBO' : 'แก้ไขลูกค้า SBO'
      apiClient.get('/system/getPartnerSBO').then(res => {
        if (res.data.code === '000') {
          this.Partner = []
          this.Partner = res.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
      apiClient.get('/system/getBank').then(res => {
        if (res.data.code === '000') {
          this.bank = []
          this.bank = res.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
      this.widthModal = '560px'
      this.styleForm = 'padding: 0; border-style: none;'
      this.styleCheck = 'padding: 0  0 0 18px; display: none;'
      this.spanForm = 24
      this.spanCheck = 0
      if (type === 'update') {
        this.getDataMemberSBO(id)
        this.disabledCheck = false
        if (bankAcountCode !== null && bankAcountCode !== '') {
          this.disabledBank = true
        }
        this.styleButton = 'display: none;'
      } else {
        this.styleButton = 'display: block;'
        this.visible = !this.visible
      }
    // apiClient.get('/system/getPartnerSBO').then(res => {
    //   if (res.data.code === '000') {
    //     this.Partner = []
    //     this.Partner = res.data.responseData.data
    //     if (type === 'update') {
    //       this.getDataMemberSBO(id)
    //     } else {
    //       this.visible = !this.visible
    //     }
    //   }
    // }).catch(error => {
    //   Swal.showValidationMessage(
    //     `เกิดข้อผิดพลาด: ${error}`,
    //   )
    // })
    },
    getDataMemberSBO(id) {
      apiClient.get(`/memberSBO/getDataMemberSBO/${id}`).then(res => {
        if (res.data.code === '000') {
          const dataBlackLis = res.data.responseData.data[0]
          this.form.memberSBOId = dataBlackLis.id
          this.form.partnerSboId = dataBlackLis.partnerSboId
          this.form.username = dataBlackLis.username
          this.form.phoneNumber = dataBlackLis.phoneNumber
          this.form.bankId = dataBlackLis.bankId
          this.form.bankAccountName = dataBlackLis.bankAccountName
          this.form.bankAccountNumber = dataBlackLis.bankAccountNumber
          this.form.lineId = dataBlackLis.lineId

          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    clearForm() {
      this.form = {
        memberSBOId: null,
        partnerSboId: null,
        username: null,
        phoneNumber: null,
        bankId: null,
        bankAccountName: null,
        bankAccountNumber: null,
        lineId: null,
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = (this.form.type === 'update') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              this.confirmLoadingCheck = true
              if (value) {
              // ส่งข้อมูลอัปเดทสถานะ
                if (this.form.memberSBOId) {
                  return apiClient.put(`memberSBO/update/${this.form.memberSBOId}`, this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                          `เกิดข้อผิดพลาด: ${error}`,
                    )
                  })
                } else {
                  return apiClient.post('memberSBO/create', this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                          `เกิดข้อผิดพลาด: ${error}`,
                    )
                  })
                }
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              if (result.value.responseData.data) {
                const iconError = (result.value.responseData.data.code === '000') ? 'success' : 'error'
                Toast.fire({ icon: iconError, title: result.value.responseData.data.message })
              } else {
                const iconError = (result.value.code === '000') ? 'success' : 'error'
                Toast.fire({ icon: iconError, title: result.value.message })
              }
              // const iconError = (result.value.code === '000') ? 'success' : 'error'
              // Toast.fire({ icon: iconError, title: result.value.message })
              this.visible = false
              this.disabledBank = false
              this.disabledCheck = true
              this.confirmLoadingCheck = false
              this.widthModal = '560px'
              this.styleForm = 'padding: 0; border-style: none;'
              this.styleCheck = 'padding: 0  0 0 18px; display: none;'
              this.spanForm = 24
              this.spanCheck = 0
              this.getBlackList()
            }
          })
        }
      })
    },
    updateStatus(id, status) {
      apiClient.put(`/memberSBO/updateStatus/${id}`, { status: status }).then(res => {
        if (res.data.code === '000') {
          const iconError = (res.data.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: res.data.message })
          this.getBlackList()
        }
      }).catch(error => {
        Swal.showValidationMessage(
                  `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    handleOk(e) {
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },
    sendCheckBankAccount() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.userBank = {
            icon: null,
            bank: null,
            accountNumber: null,
            accountName: null,
            accountToDisplayName: null,
          }
          const body = {
            bankId: this.form.bankId,
            accountNumber: this.form.bankAccountNumber,
          }
          this.spanForm = 12
          this.spanCheck = 12
          this.widthModal = '1000px'
          this.styleForm = 'padding: 0 18px 0 0; border-style: none inset none none;'
          this.styleCheck = 'padding: 0  0 0 18px; display: block;'
          this.spinning = !this.spinning
          apiClient.post('/users/checkBank', body).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            if (res.code === '000') {
              this.disabledCheck = !this.disabledCheck
              const dataUserBank = res.responseData.data
              if (this.form.bankId === 5) {
                this.userBank = {
                  icon: dataUserBank.bankIcon,
                  bank: dataUserBank.bankName,
                  accountNumber: dataUserBank.accountNumber,
                  accountName: '-',
                  accountToDisplayName: dataUserBank.accountToName,
                }
              } else {
                this.userBank = {
                  icon: dataUserBank.bankIcon,
                  bank: dataUserBank.bankName,
                  accountNumber: dataUserBank.accountNumber,
                  accountName: dataUserBank.accountToName,
                  accountToDisplayName: dataUserBank.accountToDisplayName,
                }
              }
            }
            this.spinning = !this.spinning
          }).catch(error => {
            this.spinning = !this.spinning
            Toast.fire({ icon: 'error', title: error })
          })
        }
      })
    },
    checkBankAccount(item) {
      this.disabledCheck = true
      this.userBank = {
        icon: null,
        bank: null,
        accountNumber: null,
        accountName: null,
        accountToDisplayName: null,
      }
      this.formcheck = {
        username: item.username,
        bankId: item.bankId,
        bankAccountName: item.bankAccountName,
        accountNumber: item.bankAccountNumber,
      }
      apiClient.get('/system/getBank').then(res => {
        if (res.data.code === '000') {
          this.bank = []
          this.bank = res.data.responseData.data
        }
      }).catch(error => {
        Toast.fire({ icon: 'error', title: error })
      })
      this.visibleCheckBankAccount = !this.visibleCheckBankAccount
    },
    async handleOkCheck(e) {
      this.confirmLoadingCheck = true
      // const onDate = new Date()
      // const sendTimeAt = moment(onDate).format('x')

      // await axios.post('http://18.136.67.221:3007/service/bankAccount', {
      //   username: this.formcheck.username,
      //   accountName: this.formcheck.bankAccountName,
      //   accountNumber: this.userBank.accountNumber,
      //   bankId: this.formcheck.bankId,
      //   sendTimeAt: sendTimeAt,
      // }, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     secureCode: 'ERRWHB',
      //   },
      const body = {
        username: this.formcheck.username,
        accountName: this.formcheck.bankAccountName,
        accountNumber: this.userBank.accountNumber,
        bankId: this.formcheck.bankId,
      }
      apiClient.post('/memberSBO/bankAccount', body).then(res => {
        if (res.data.responseData.data) {
          const iconError = (res.data.responseData.data.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: res.data.responseData.data.message })
        } else {
          const iconError = (res.data.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: res.data.message })
        }
        this.confirmLoadingCheck = false
        this.visibleCheckBankAccount = !this.visibleCheckBankAccount
        this.getBlackList()
      }).catch(error => {
        this.visibleCheckBankAccount = !this.visibleCheckBankAccount
        this.confirmLoadingCheck = false
        Toast.fire({ icon: 'error', title: error })
      })
    },
    handleCancelCheck(e) {
      this.visibleCheckBankAccount = !this.visibleCheckBankAccount
    },
    // updateBankAccountCode(bankAcountCode) {
    //   apiClient.post('/memberSBO/updateBankAcountCode', { bankAcountCode: bankAcountCode, username: this.formcheck.username }).then(res => {
    //     if (res.data.code === '000') {
    //       const iconError = (res.data.code === '000') ? 'success' : 'error'
    //       Toast.fire({ icon: iconError, title: res.data.message })
    //       this.getBlackList()
    //     }
    //   }).catch(error => {
    //     Toast.fire({ icon: 'error', title: error })
    //   })
    // },
    async sendCheckBankAccountUpdate() {
      this.userBank = {
        icon: null,
        bank: null,
        accountNumber: null,
        accountName: null,
        accountToDisplayName: null,
      }
      this.spinning = !this.spinning
      await apiClient.post('/users/checkBank', this.formcheck).then(response => {
        const res = response.data
        const iconError = (res.code === '000') ? 'success' : 'error'
        Toast.fire({ icon: iconError, title: res.message })
        if (res.code === '000') {
          this.disabledCheck = !this.disabledCheck
          const dataUserBank = res.responseData.data
          if (this.formcheck.bankId === 5) {
            this.userBank = {
              icon: dataUserBank.bankIcon,
              bank: dataUserBank.bankName,
              accountNumber: dataUserBank.accountNumber,
              accountName: '-',
              accountToDisplayName: dataUserBank.accountToName,
            }
          } else {
            this.userBank = {
              icon: dataUserBank.bankIcon,
              bank: dataUserBank.bankName,
              accountNumber: dataUserBank.accountNumber,
              accountName: dataUserBank.accountToName,
              accountToDisplayName: dataUserBank.accountToDisplayName,
            }
          }
        }
        this.spinning = !this.spinning
      }).catch(error => {
        Toast.fire({ icon: 'error', title: error })
      })
    },
  },
  async created() {
    await this.getBlackList()
  },
}
</script>

<style>

</style>
